import { render, staticRenderFns } from "./VcitaInfo.vue?vue&type=template&id=45a75923"
import script from "./VcitaInfo.vue?vue&type=script&lang=js"
export * from "./VcitaInfo.vue?vue&type=script&lang=js"
import style0 from "./VcitaInfo.vue?vue&type=style&index=0&id=45a75923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports